export default __webpack_public_path__ + "static/fin-ins-coverage-73706d818019103b55693be5846a047a.png";